import { ReactFC } from 'common/types/ReactFC'
import ImageCard from './base/ImageCard'
import Strings from 'project/localisation'
import { mailroomStrings } from 'common/strings/mailroom-strings' // we need this to make JSX compile

export type DivertYourPostCardType = {}

const DivertYourPostCard: ReactFC<DivertYourPostCardType> = ({ children }) => {
  return (
    <ImageCard
      reverseColumnsDesktop
      padding='0'
      verticalAlign='center'
      className='mt-xxxl-64 mt-lg-25 mt-64 mx-xs-0 mx-2'
      textAlign='center'
      imageAlt={`${Strings.ourAddress} icon`}
      image={require('public/images/mailroom/mailroom-page-divert-post-desktop.png')}
      imageClass={
        'position-lg-absolute top-0 bottom-0 end-0 mb-xxl-0 my-auto max-w-xxxl-md-50 mt-lg-auto mt-n42 img-mobile-fullwidth2'
      }
      mobileImageProps={{ className: 'm-auto' }}
      mobileImage={require('public/images/mailroom/mailroom-page-divert-post-desktop.png')}
      classNameForCol1={
        'col-lg-6 ps-xxl-26 ps-xl-18 ps-lg-12 pe-xxl-18 pe-lg-0 px-8 py-xxxl-18 py-lg-7 pt-6 pb-10'
      }
      classNameForCol2={'col-lg-6'}
    >
      <h3
        className='h2 text-semibold mb-lg-1 mb-6'
        dangerouslySetInnerHTML={{
          __html: mailroomStrings.divertYourPost,
        }}
      />
      <div
        className={'lead'}
        dangerouslySetInnerHTML={{
          __html: mailroomStrings.divertYourPostDescription,
        }}
      />
    </ImageCard>
  )
}

export default DivertYourPostCard
